<template>
	<li :id="'claim-' + result.ClaimID" v-on:click="displayDetail(result)" v-on:keydown.enter="displayDetail(result)" tabindex="0">
		<span class="list-item-info claim-type">
			<span class="label">Claim Type</span>
			<span class="value">{{result.ClaimType}}</span>
			<span v-if="result.ClaimType === ''" class="novalue">N/A</span>
		</span>
		<span class="list-item-info po-number">
			<span class="label">PO #</span>
			<span class="value">{{result.DealerPONumber}}</span>
			<span v-if="result.DealerPONumber === ''" class="novalue">N/A</span>
		</span>
		<span class="list-item-info lmc-inv">
			<span class="label">LMC Inv #</span>
			<span class="value">{{result.LMCInvoiceNumber}}</span>
			<span v-if="result.LMCInvoiceNumber === ''" class="novalue">N/A</span>
		</span>
		<span class="list-item-info supplier">
			<span class="label">Supplier</span>
			<span v-html="result.SupplierName" class="value"></span>
			<span v-if="result.SupplierName === ''" class="novalue">N/A</span>
		</span>
		<span class="list-item-info submit-date">
			<span class="label">Date Submitted</span>
			<span class="value">{{formatDate(result.DateClaimSubmitted)}}</span>
			<span v-if="result.DateClaimSubmitted === ''" class="novalue">N/A</span>
		</span>
		<span class="list-item-info processed">
			<span class="label">Processed</span>
			<span v-if="result.IsProcessed" class="value">Yes</span>
			<span v-if="!result.IsProcessed" class="value unprocessed">No</span>
		</span>
		<span class="list-item-info processed-date">
			<span class="label">Date Processed</span>
			<span class="value" v-if="result.DateProcessed >= result.DateClaimSubmitted">{{formatDate(result.DateProcessed)}}</span>
			<span class="value hide-desktop unprocessed" v-if="result.DateProcessed == null">NOT PROCESSED</span>
		</span>
		
	</li>


</template>

<script>
	import DateFormatService from '../../common/date-format.service';
	import ClaimsHistoryDetail from './claims-history-detail';
	import { create } from 'vue-modal-dialogs';

	const claimDetail = create(ClaimsHistoryDetail, 'claim');

	export default {
		props: {
				result: {
					type: Object,
					default: () => {}
				}
		},
		data: function () {
			return {

			}
		},
		methods: {
			displayDetail(result) {
				$('body').addClass('dim claims-print');
				claimDetail(result);
			},
			formatDate: function (date) {
				return DateFormatService.customFormatter(date, 'full-slash');
			}	
		}
	}

</script>